export default __webpack_public_path__ + "c0818e7fda2e8663e5afb567602f1b21.png";